import React from "react"
import engImage from "../../../assest/images/leitner/LethnerBG-En.svg";
import arImage from "../../../assest/images/leitner/LethnerBG-Ar.svg";
import frImage from "../../../assest/images/leitner/LethnerBG-Fa.svg";
import ponsadChaharImage from "../../../assest/images/leitner/LethnerBG-504.svg";
import costumImage from "../../../assest/images/leitner/LethnerBG-Custom.svg";
import LeitnerBoxListState, { LeitnerBoxListProps } from "./LeitnerBoxList.models";
import { LeitnerBoxView } from "../../../leitner/shared/leitner-box/LeitnerBox.models";
import LearningBoxList from "../../../leitner/learning-box-list/LearningBoxList";
import './LeitnerBoxList.scss';
import LearningBoxService from "../../../services/content/LearningBoxService";

export default class LeitnerBoxList extends React.PureComponent<LeitnerBoxListProps, LeitnerBoxListState> {

    learningBoxService: LearningBoxService;
    constructor(props: LeitnerBoxListProps) {
        super(props);
        this.learningBoxService = new LearningBoxService();
        // let boxs: LeitnerBoxView[] = [];
        // boxs.push({ title: "زبان انگیلیسی", imageSource: engImage, redirectLink: "test" });
        // boxs.push({ title: "زبان عربی", imageSource: arImage, redirectLink: "test" });
        // boxs.push({ title: "زبان فارسی", imageSource: frImage, redirectLink: "test" });
        // boxs.push({ title: "لغات 504", imageSource: ponsadChaharImage, redirectLink: "test" });
        this.state = { leitnerBoxs: [] };
    }

    componentDidMount() {
        this.getPaged();
    }

    componentDidUpdate(prevProps: LeitnerBoxListProps) {
        if (prevProps.showActions !== this.props.showActions && this.props.showActions !== null && this.props.showActions !== undefined)
            this.getPaged();
    }

    getPaged = () => {
        let state = this;
        let attachmentId: "https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=";
        this.learningBoxService.getPaged({ isCustomBox: this.props.showActions }).then(response => {

            var leitnerBoxs: LeitnerBoxView[] = response.map(data => {
                return {
                    title: data.title,
                    imageSource: data.attachmentId !== null && data.attachmentId !== undefined ? attachmentId + data.attachmentId : costumImage,
                    redirectLink: data.id
                }
            });

            state.setState({ leitnerBoxs: leitnerBoxs });
        })
    }


    render(): React.ReactNode {
        let { leitnerBoxs } = this.state;
        let { showActions } = this.props;
        return <>
            <div className="dropdown-list " style={{ height: "90vh" }} >
                <LearningBoxList leitnerBoxs={leitnerBoxs} config={{ hasPlusButton: showActions, navigateLink: "/CreateLeitner", showMyLeitnerRedirector: !showActions }} />
            </div>
        </>;
    }
}